import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Button } from 'Components/Button'
import { DatePicker } from 'Components/DatePicker'
import { FormInputFoodAmount } from 'Components/FormInputFoodAmount'
import { FormInputSelect } from 'Components/FormInputSelect'
import {
  SelectItemKeyExtractor,
  SelectItemRenderer,
  SelectItemType,
  defaultKeyExtractor
} from 'Components/common/SelectPickerProps'
import { Amount, Food, MealCategory, QuantifiedEatable, Recipe, allMealCategories } from 'Models'
import { setJournalDateAction } from 'ReduxStore/journalDay'
import { postOrPatchJournalEatableRecordAction } from 'ReduxStore/journalEatableRecords'
import { Formatter, Utils } from 'Utils'

interface Props {
  recipe?: Recipe
  food?: Food
  quantifiedEatable?: QuantifiedEatable
}

export const AddEatableToJournal: FC<Props> = ({ recipe, food, quantifiedEatable }) => {
  const dispatch = useDispatch()

  const history = useHistory()

  const eatable = recipe ? { recipe } : { food }

  const { quantity, unit } = quantifiedEatable || {}

  const [amount, setAmount] = useState<Amount>(
    quantity && unit ? { quantity, unit } : Utils.defaultEatableAmount(eatable)
  )

  const [date, setDate] = useState<Date>(new Date())

  const [category, setCategory] = useState<MealCategory>(() => Utils.currentMealCategory())

  const availableUnits = Utils.availableUnits(eatable)

  const handleCategoryChange = (category: SelectItemType): void => {
    setCategory(category as MealCategory)
  }

  const handleSave = async (): Promise<void> => {
    const result = await dispatch(
      postOrPatchJournalEatableRecordAction(
        { ...eatable, quantity: amount.quantity, unit: amount.unit },
        category,
        date,
        recipe ? 'recipe-details' : food ? 'food-details' : ''
      )
    )

    if ('error' in result) {
      return
    }

    dispatch(setJournalDateAction(date))
    history.push('/tagebuch')
  }

  return (
    <div className="detailcard-panel detailcard-add-to-journal px-2 py-1">
      <FormInputFoodAmount
        label=" "
        amount={amount}
        availableUnits={availableUnits}
        onAmountChange={setAmount}
        onChangeDelay={0}
      />

      <DatePicker label=" " value={date} onChange={setDate} />

      <div className="meal-category">
        <FormInputSelect
          label=" "
          name="mealCategory"
          items={allMealCategories}
          selectedKey={category ? defaultKeyExtractor(category) : undefined}
          labelExtractor={Formatter.formatMealCategory as SelectItemRenderer<SelectItemType, string>}
          keyExtractor={defaultKeyExtractor as SelectItemKeyExtractor<SelectItemType>}
          onChange={handleCategoryChange}
        />
      </div>

      <div>
        <Button name="saveJournalCard" theme="small" onClick={handleSave}>
          Speichern
        </Button>
      </div>
    </div>
  )
}
